import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface NetworkStatsProps {
  className?: string;
}

const NetworkStats = ({ className = '' }: NetworkStatsProps) => {
  const stats = [
    {
      number: "< 200",
      label: "Global Members",
      description: "Carefully selected worldwide",
      icon: "UsersIcon"
    },
    {
      number: "47",
      label: "Countries Represented",
      description: "Six continents of influence",
      icon: "GlobeAltIcon"
    },
    {
      number: "89%",
      label: "Advanced Degrees",
      description: "PhD, MD, JD credentials",
      icon: "AcademicCapIcon"
    },
    {
      number: "156",
      label: "Years Combined Experience",
      description: "Average exploration expertise",
      icon: "ClockIcon"
    }
  ];

  return (
    <div data-component-id="src/app/elite-network/components/NetworkStats.tsx:37:4" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="37" data-component-file="NetworkStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ${className}`}>
      {stats.map((stat, index) => (
        <div data-component-id="src/app/elite-network/components/NetworkStats.tsx:39:8" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="39" data-component-file="NetworkStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20border%20border-border%20rounded-lg%20p-6%20text-center%20hover%3Ashadow-institutional%20transition-all%20duration-300%20group%22%7D"
          key={index}
          className="bg-card border border-border rounded-lg p-6 text-center hover:shadow-institutional transition-all duration-300 group"
        >
          <div data-component-id="src/app/elite-network/components/NetworkStats.tsx:43:10" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="43" data-component-file="NetworkStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mb-4%22%7D" className="flex justify-center mb-4">
            <div data-component-id="src/app/elite-network/components/NetworkStats.tsx:44:12" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="44" data-component-file="NetworkStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-12%20h-12%20bg-accent%2F10%20rounded-full%20flex%20items-center%20justify-center%20group-hover%3Abg-accent%2F20%20transition-colors%20duration-300%22%7D" className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center group-hover:bg-accent/20 transition-colors duration-300">
              <Icon data-component-id="src/app/elite-network/components/NetworkStats.tsx:45:14" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="45" data-component-file="NetworkStats.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-accent%22%7D" 
                name={stat.icon as any} 
                size={24} 
                className="text-accent"
              />
            </div>
          </div>
          <div data-component-id="src/app/elite-network/components/NetworkStats.tsx:52:10" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="52" data-component-file="NetworkStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22font-playfair%20font-bold%20text-3xl%20text-primary%20mb-2%22%7D" className="font-playfair font-bold text-3xl text-primary mb-2">
            {stat.number}
          </div>
          <div data-component-id="src/app/elite-network/components/NetworkStats.tsx:55:10" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="55" data-component-file="NetworkStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22font-inter%20font-semibold%20text-text-primary%20mb-1%22%7D" className="font-inter font-semibold text-text-primary mb-1">
            {stat.label}
          </div>
          <div data-component-id="src/app/elite-network/components/NetworkStats.tsx:58:10" data-component-path="src/app/elite-network/components/NetworkStats.tsx" data-component-line="58" data-component-file="NetworkStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22font-inter%20text-sm%20text-text-secondary%22%7D" className="font-inter text-sm text-text-secondary">
            {stat.description}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NetworkStats;